var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useBreakpoint, Pagination, PaginationCompact, PaginationDisplayedItemCount, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useCommonContext, usePurchaseHistoryContext, } from '../../hooks/useContexts';
import { getNumPages, getWindow } from '../../utils/general';
export var PHPagination = function () {
    var _a;
    var svocID = useThdCustomer().svocID;
    var isTablet = useCommonContext().isTablet;
    var _b = usePurchaseHistoryContext(), orderHistoryData = _b.orderHistoryData, orderHistoryLoaded = _b.orderHistoryLoaded, orderHistoryError = _b.orderHistoryError, pHRequest = _b.pHRequest, setPHRequest = _b.setPHRequest, viewType = _b.viewType;
    var isTabletAndDesktop = useBreakpoint('md').greater || isTablet;
    var totalNumberOfOrders = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.itemsCount) || 0;
    if (!orderHistoryLoaded ||
        orderHistoryError !== undefined ||
        totalNumberOfOrders === 0 ||
        ((_a = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _a === void 0 ? void 0 : _a.length) === 0 ||
        viewType === 'LocalDeliveries') {
        return null;
    }
    return (React.createElement("div", { className: "sui-grow", "data-testid": "pagination-compact-and-item-count" },
        React.createElement("div", { className: "sui-relative sui-flex sui-items-center sui-gap-4 sui-flex-col-reverse sm:sui-flex-row sm:sui-gap-0" },
            React.createElement(PaginationDisplayedItemCount, { page: pHRequest.pageNumber, itemsPerPage: 20, items: totalNumberOfOrders }),
            isTabletAndDesktop ? (React.createElement(Pagination, { count: getNumPages(20, totalNumberOfOrders), page: pHRequest.pageNumber, onChange: function (_event, selectedPage) {
                    var _a, _b;
                    setPHRequest(function (prevState) {
                        return __assign(__assign({}, prevState), { pageNumber: selectedPage });
                    });
                    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0 });
                    (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.setItem('purchaseHistoryPage', JSON.stringify({
                        lastPage: selectedPage,
                        ODLastVisited: undefined,
                        id: svocID,
                    }));
                }, siblingCount: 1, boundaryCount: 1, showFirstButton: true, showLastButton: true })) : (React.createElement(PaginationCompact, { count: getNumPages(20, totalNumberOfOrders), page: pHRequest.pageNumber, onChange: function (_event, selectedPage) {
                    var _a, _b;
                    setPHRequest(function (prevState) {
                        return __assign(__assign({}, prevState), { pageNumber: selectedPage });
                    });
                    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0 });
                    (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.setItem('purchaseHistoryPage', JSON.stringify({
                        lastPage: selectedPage,
                        ODLastVisited: undefined,
                        id: svocID,
                    }));
                } })))));
};
